export const graphTypes = [
    {
        id: 1,
        name: "Amplitude 1D"
    },
    {
        id: 2,
        name: "Amplitude 2D"
    },
    {
        id: 4,
        name: "Galaxy"
    },
    {
        id: 5,
        name: "Temporal Width"
    },
    {
        id: 6,
        name: "Width Distribution"
    },
    {
        id: 7,
        name: "Event Frequency"
    },
    {
        id: 8,
        name: "Event Spacing Distribution"
    },
    {
        id: 9,
        name: "Temporal Correlation"
    },
    {
        id: 10,
        name: "Correlation Distribution "
    }
];
// Removed from dropdown — no backend/cache support:
//   Amplitude Distribution (id 3)
//   Droplet Packs (id 11) — SignalProcessing.Time not in Redshift
//   Reader Time Utilization (id 12) — SignalProcessing.Time not in Redshift

export const Channels = [

    {
        id: 1,
        name: "Ch1"
    },

    {
        id: 2,
        name: "Ch2"
    },

    {
        id: 3,
        name: "Ch3"
    },
    {
        id: 4,
        name: "Ch4"
    },
    {
        id: 5,
        name: "Ch5"
    },
    {
        id: 6,
        name: "Ch6"
    }

];
